var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeller2Net({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 8.5L8 30.5M12 16.5V8.5M8 12.5H16M22 26.5H30M10.6 37.5H27.4C30.7603 37.5 32.4405 37.5 33.7239 36.846C34.8529 36.2708 35.7708 35.3529 36.346 34.2239C37 32.9405 37 31.2603 37 27.9V11.1C37 7.73969 37 6.05953 36.346 4.77606C35.7708 3.64708 34.8529 2.7292 33.7239 2.15396C32.4405 1.5 30.7603 1.5 27.4 1.5H10.6C7.23969 1.5 5.55953 1.5 4.27606 2.15396C3.14708 2.7292 2.2292 3.64708 1.65396 4.77606C1 6.05953 1 7.73968 1 11.1V27.9C1 31.2603 1 32.9405 1.65396 34.2239C2.2292 35.3529 3.14708 36.2708 4.27606 36.846C5.55953 37.5 7.23968 37.5 10.6 37.5Z",
    stroke: "#091DF2",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeller2Net);
export default __webpack_public_path__ + "static/media/seller2net.bef45fb99def668cf5bde1dddfd5621c.svg";
export { ForwardRef as ReactComponent };